import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Columns } from 'src/components'
import { Icon, ChevronRightIcon } from 'src/components/icons'
import RawDatetimeInput from '../RawDatetimeInput'

/**
 * A period input with very light style
 */
const RawPeriodInputs = ({ value: [from, to], onChange, now, color, disabledDate, ...props }) => {
  const disabledDateFrom = from =>
    (to && moment(from).isAfter(to)) || (now && moment(now).isBefore(from)) || (disabledDate && disabledDate(from))
  const disabledDateTo = to =>
    (from && moment(from).isAfter(to)) ||
    (now &&
      moment(now)
        .endOf('day')
        .isBefore(to)) ||
    (disabledDate && disabledDate(to))

  return (
    <Columns layout="1 auto 1" align="center" {...props}>
      <RawDatetimeInput
        value={from}
        onChange={value => (value ? onChange([value, to]) : onChange([value, null]))}
        disabledDate={disabledDateFrom}
      />
      <Icon icon={ChevronRightIcon} color={color} fixedWidth />
      <RawDatetimeInput
        value={to}
        onChange={value => onChange([from, value])}
        disabled={!from}
        disabledDate={disabledDateTo}
      />
    </Columns>
  )
}

RawPeriodInputs.defaultProps = {
  onChange: () => {},
  value: {},
}
RawPeriodInputs.propTypes = {
  /**
   * Array of dates. First element is the start of the period, second one is the end.
   */
  value: PropTypes.array.isRequired,
  /**
   * Function called when period is changed.
   */
  onChange: PropTypes.func,
  /**
   * The current date, used for input restriction
   */
  now: PropTypes.instanceOf(Date),
  color: PropTypes.string,
  disabledDate: PropTypes.func,
}

export default RawPeriodInputs
